module.exports = __webpack_public_path__ + "img/paymentwall.7d452712.svg";